import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IsCompleted } from './../../model';

@Component({
  selector: 'app-complete-checkbox',
  templateUrl: './completedItem.component.html'
})
export class CompletedCheckboxComponent implements OnInit {
  @Output() completedCheckboxStatus = new EventEmitter();
  @ViewChild('completed') private completedCheckbox: ElementRef;
  @ViewChild('incompleted') private incompletedCheckbox: ElementRef;

  applied: Boolean;
  status: number;

  completed: any;
  incompleted: any;
  isCompleted: Boolean;
  isIncompleted: Boolean;

  constructor(
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
  }

  ngOnInit() {
    this.completed = this.completedCheckbox.nativeElement;
    this.incompleted = this.incompletedCheckbox.nativeElement;

    this.isCompleted = false;
    this.isIncompleted = true;

    this.applied = true;
    this.status = IsCompleted.incompleted;
    this.emitStatus();
  }

  public checkboxChange(): void {
    if (this.isCompleted === this.completed.checked && this.isIncompleted === this.incompleted.checked) {
      this.applied = true;
    } else if ( this.completed.checked || this.incompleted.checked) {
      this.applied = false;
    } else {
      this.applied = true;
    }

    this.statusChange();
  }

  public emitStatus(): void {
    this.completedCheckboxStatus.emit({
      completedCheckboxStatus: this.status,
      // compeletedCheckbox: this.completed.checked,
      // incompletedCheckbox: this.incompleted.checked
      isApply: this.applied
    });
  }

  public statusChange(): void {
    this.isCompleted = this.completed.checked;
    this.isIncompleted = this.incompleted.checked;

    switch (true) {
      case this.completed.checked && this.incompleted.checked:
        this.status = IsCompleted.both;
        break;
      case this.completed.checked && !this.incompleted.checked:
        this.status = IsCompleted.completed;
        break;
      case !this.completed.checked && this.incompleted.checked:
        this.status = IsCompleted.incompleted;
        break;
      case !this.completed.checked && !this.incompleted.checked:
        this.status = IsCompleted.both;
        break;
      default:
        this.status = IsCompleted.completed;
        break;
    }

    this.emitStatus();
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/shared/completedItem.component.ts